import React from 'react';
import { DetailsGrid, DetailItem, DetailLabel, DetailInput } from './Styles';
import { LABELS, getRoleDisplayName } from './constants';
import type { ContactDetailsSectionProps } from './types';

const ContactDetailsSection: React.FC<ContactDetailsSectionProps> = ({
  user,
  role,
}) => {
  if (!user) return null;

  const usernameDisplay = user.username ? `@${user.username}` : '—';
  const roleDisplay = getRoleDisplayName(role);

  return (
    <DetailsGrid>
      <DetailItem>
        <DetailLabel>{LABELS.PHONE}</DetailLabel>
        <DetailInput value={user.phone || '—'} disabled />
      </DetailItem>
      <DetailItem>
        <DetailLabel>{LABELS.EMAIL}</DetailLabel>
        <DetailInput type="email" value={user.email || '—'} disabled />
      </DetailItem>
      <DetailItem>
        <DetailLabel>{LABELS.USERNAME}</DetailLabel>
        <DetailInput value={usernameDisplay} disabled />
      </DetailItem>
      <DetailItem>
        <DetailLabel>{LABELS.ROLE}</DetailLabel>
        <DetailInput value={roleDisplay} disabled />
      </DetailItem>
    </DetailsGrid>
  );
};

export default React.memo(ContactDetailsSection);
